var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg52(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4466_96811)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.07813 7.53125H16.9219V0.5H7.07813V7.53125ZM8.48438 6.125V1.90625H15.5156V6.125H8.48438Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2188 3.3125H7.78125V4.71875H16.2188V3.3125Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.26562 24.5H19.7344V18.1719C19.7344 16.2302 18.1604 14.6562 16.2188 14.6562H14.1094V14.1806C15.6119 13.4556 16.6822 11.9462 16.8864 10.2359C17.7242 9.95657 18.3281 9.16601 18.3281 8.23436C18.3281 7.06936 17.3837 6.12499 16.2188 6.12499V7.53124C16.6071 7.53124 16.9219 7.84601 16.9219 8.23436C16.9219 8.62271 16.6071 8.93749 16.2188 8.93749H15.5156V9.64061C15.5156 11.1883 14.5214 12.5732 13.1719 13.0501L12.7031 13.2158V16.0625H16.2188C17.3837 16.0625 18.3281 17.0069 18.3281 18.1719V23.0937H5.67187V18.1719C5.67187 17.0069 6.61628 16.0625 7.78125 16.0625H11.2969V13.2158L10.8281 13.0501C9.47864 12.5732 8.48438 11.1883 8.48438 9.64061V8.93749H7.78125C7.3929 8.93749 7.07812 8.62271 7.07812 8.23436C7.07812 7.84601 7.3929 7.53124 7.78125 7.53124V6.12499C6.61625 6.12499 5.67188 7.06936 5.67188 8.23436C5.67188 9.16601 6.27582 9.95657 7.11358 10.2359C7.31784 11.9462 8.3881 13.4556 9.89063 14.1806V14.6562H7.78125C5.83963 14.6562 4.26562 16.2302 4.26562 18.1719V24.5Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 19.7441L14.0351 15.6738L12.7774 15.0449L12 16.5996L11.2226 15.0449L9.96486 15.6738L12 19.7441Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2969 18.1719V23.7969H12.7031V18.1719H11.2969Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.48438 23.7969V15.3594H7.07813V23.7969H8.48438Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5156 15.3594V23.7969H16.9219V15.3594H15.5156Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4466_96811"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg52);
export default __webpack_public_path__ + "static/media/52.33b8b90f3009b6dcdd13125a0482ecab.svg";
export { ForwardRef as ReactComponent };